/**
 * Escalation-related enums and types
 * Used across engagement module components
 */

export enum EscalationKey {
  E1_1 = "E1_1",
  E1_2 = "E1_2",
  E1_3 = "E1_3",
  E1_4 = "E1_4",
  E2_1 = "E2_1",
  E2_2 = "E2_2",
  E2_3 = "E2_3",
  E2_4 = "E2_4",
  E2_5 = "E2_5",
  E2_6 = "E2_6",
  E3_1 = "E3_1",
  E3_2 = "E3_2",
  E3_3 = "E3_3",
  E3_4 = "E3_4",
  E3_5 = "E3_5",
  E3_6 = "E3_6",
  E3_7 = "E3_7",
  E3_8 = "E3_8",
  E4_1 = "E4_1",
  E4_2 = "E4_2",
  E4_3 = "E4_3",
  E5_1 = "E5_1",
  E5_2 = "E5_2",
}

export enum EscalationParent {
  E1 = "Raising Concerns",
  E2 = "Collaborative Measure",
  E3 = "Shareholder Advocacy",
  E4 = "Capital Allocation Decisions",
  E5 = "Levers of Last Resort",
}

export type EscalationType = {
  key: EscalationKey;
  description: string;
  isActive: boolean;
};

export type EscalationParentType = {
  key: 1 | 2 | 3 | 4 | 5;
  title: EscalationParent;
  escalations: EscalationType[];
  color: string;
};

/**
 * Helper to get escalation level from key like "E2_4" -> 2
 */
export const getEscalationLevel = (key: string): number => {
  const match = key.match(/^E(\d)/i);
  return match ? parseInt(match[1], 10) : 1;
};

/**
 * Helper to format escalation key for display: "E2_4" -> "E24"
 */
export const formatEscalationCode = (key: string): string => {
  return key.replace("_", "");
};
